
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("j00wp", function(module, exports) {

$parcel$export(module.exports, "WatchDialogShortcut", () => $dd4e6bfccdb6ea02$export$f6ed78329bec3e69);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $2nPZH = parcelRequire("2nPZH");
var $js7oX = parcelRequire("js7oX");

var $j1Ss3 = parcelRequire("j1Ss3");

var $inPa6 = parcelRequire("inPa6");

var $ljm2R = parcelRequire("ljm2R");

var $gqqjz = parcelRequire("gqqjz");

var $efvKr = parcelRequire("efvKr");

var $9wGTI = parcelRequire("9wGTI");

var $de2j9 = parcelRequire("de2j9");

var $kgw3S = parcelRequire("kgw3S");

var $sRTqL = parcelRequire("sRTqL");

var $kcnoC = parcelRequire("kcnoC");

var $jle6C = parcelRequire("jle6C");
const $dd4e6bfccdb6ea02$var$i18n = (0, $2nPZH.defineMessages)({
    watchPageNotification: {
        id: "watch-dialog.notification.start.watching.page",
        defaultMessage: "You started watching this content."
    },
    unwatchPageNotification: {
        id: "watch-dialog.notification.stop.watching.page",
        defaultMessage: "You stopped watching this content."
    },
    watchBlogNotification: {
        id: "watch-dialog.notification.start.watching.blog",
        defaultMessage: "You started watching this blog."
    },
    unwatchBlogNotification: {
        id: "watch-dialog.notification.stop.watching.blog",
        defaultMessage: "You stopped watching this blog."
    },
    watchWhiteboardNotification: {
        id: "watch-dialog.notification.start.watching.whiteboard",
        defaultMessage: "You started watching this whiteboard."
    },
    unwatchWhiteboardNotification: {
        id: "watch-dialog.notification.stop.watching.whiteboard",
        defaultMessage: "You stopped watching this whiteboard."
    },
    watchDatabaseNotification: {
        id: "watch-dialog.notification.start.watching.database",
        defaultMessage: "You started watching this database."
    },
    unwatchDatabaseNotification: {
        id: "watch-dialog.notification.stop.watching.database",
        defaultMessage: "You stopped watching this database."
    }
});
const $dd4e6bfccdb6ea02$var$WatchDialogShortcutHandler = ({ contentId: contentId, contentType: contentType, params: params, flagsContainer: flagsContainer, openDialog: openDialog, updateQueryHandler: updateQueryHandler, intl: intl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const { isWatchingContent: isWatchingContent, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren, isWatchingSpace: isWatchingSpace } = params;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const fireAnalyticsEvent = (action, actionSubject)=>{
        const analyticsData = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: contentId,
            objectId: contentId,
            objectType: contentType,
            source: 'WatchDialogShortcut',
            attributes: {
                componentVersion: 'v2'
            }
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: analyticsData
        }).fire();
    };
    const [unwatchContent] = (0, $j1Ss3.useMutation)((0, $kgw3S.WatchDialogUnwatchContentMutation), {
        onCompleted: ()=>{
            fireAnalyticsEvent((0, $jle6C.UpdateType).UNWATCH, (0, $jle6C.UpdateContentType).CONTENT);
        },
        update: (cache, { data: { unwatchContent: unwatchContent } })=>{
            updateQueryHandler(cache, (0, $jle6C.UpdateContentType).CONTENT, unwatchContent.content.currentUserIsWatching);
        }
    });
    const [watchContent] = (0, $j1Ss3.useMutation)((0, $sRTqL.WatchDialogWatchContentMutation), {
        onCompleted: ()=>{
            fireAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).CONTENT);
        },
        update: (cache, { data: { watchContent: watchContent } })=>{
            updateQueryHandler(cache, (0, $jle6C.UpdateContentType).CONTENT, watchContent.content.currentUserIsWatching);
        }
    });
    const getWatchNotificationContent = ()=>{
        switch(contentType){
            case (0, $kcnoC.ContentType).WHITEBOARD:
                return $dd4e6bfccdb6ea02$var$i18n.watchWhiteboardNotification;
            case (0, $kcnoC.ContentType).DATABASE:
                return $dd4e6bfccdb6ea02$var$i18n.watchDatabaseNotification;
            case (0, $kcnoC.ContentType).BLOG:
                return $dd4e6bfccdb6ea02$var$i18n.watchBlogNotification;
            default:
                return $dd4e6bfccdb6ea02$var$i18n.watchPageNotification;
        }
    };
    const getUnwatchNotificationContent = ()=>{
        switch(contentType){
            case (0, $kcnoC.ContentType).WHITEBOARD:
                return $dd4e6bfccdb6ea02$var$i18n.unwatchWhiteboardNotification;
            case (0, $kcnoC.ContentType).DATABASE:
                return $dd4e6bfccdb6ea02$var$i18n.unwatchDatabaseNotification;
            case (0, $kcnoC.ContentType).BLOG:
                return $dd4e6bfccdb6ea02$var$i18n.unwatchBlogNotification;
            default:
                return $dd4e6bfccdb6ea02$var$i18n.unwatchPageNotification;
        }
    };
    const handleShortcutClick = ()=>{
        const isImplicitlyWatching = isWatchingSpace || (hasAncestorWatchingChildren || isWatchingChildren) && (0, $9wGTI.fg)('confluence_watch_children_pages');
        if (isImplicitlyWatching) openDialog();
        else if (isWatchingContent) unwatchContent({
            variables: {
                id: contentId
            }
        }).then(()=>{
            flagsContainer.showSuccessFlag({
                title: intl.formatMessage(getUnwatchNotificationContent()),
                close: 'auto'
            });
        });
        else watchContent({
            variables: {
                id: contentId
            }
        }).then(()=>{
            flagsContainer.showSuccessFlag({
                title: intl.formatMessage(getWatchNotificationContent()),
                close: 'auto'
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $ljm2R.WATCH_CONTENT_SHORTCUT) : undefined,
        accelerator: (0, $ljm2R.UNIVERSAL_WATCH_CONTENT_SHORTCUT),
        listener: handleShortcutClick
    });
};
$dd4e6bfccdb6ea02$var$WatchDialogShortcutHandler.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    params: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).shape({
        isWatchingContent: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired,
        isWatchingChildren: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired,
        hasAncestorWatchingChildren: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired,
        isWatchingSpace: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired
    }).isRequired,
    flagsContainer: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).instanceOf((0, $gqqjz.FlagsStateContainer)),
    openDialog: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    updateQueryHandler: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object
};
const $dd4e6bfccdb6ea02$export$f6ed78329bec3e69 = (0, $js7oX.default)($dd4e6bfccdb6ea02$var$WatchDialogShortcutHandler);

});
parcelRegister("kgw3S", function(module, exports) {

$parcel$export(module.exports, "WatchDialogUnwatchContentMutation", () => $ec0e2c0a72dff83b$export$2018e5f67b7f2d76);

var $d2LG0 = parcelRequire("d2LG0");
const $ec0e2c0a72dff83b$export$2018e5f67b7f2d76 = (0, $d2LG0.default)`mutation WatchDialogUnwatchContentMutation($id:ID!){unwatchContent(watchContentInput:{contentId:$id currentUser:true}){content{id currentUserIsWatching}}}`;

});

parcelRegister("kcnoC", function(module, exports) {

$parcel$export(module.exports, "ContentType", () => $4eb3d231e333e039$export$e2e108cbe2e4f865);
var $4eb3d231e333e039$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["PAGE"] = "page";
    ContentType["BLOG"] = "blogpost";
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["DATABASE"] = "database";
    return ContentType;
}({});

});



//# sourceMappingURL=WatchDialogShortcut.a649c6dd.js.map
